import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import Link from '@buyside/components/presentation/Link/link';

import { accessIdeasUrl } from '@buyside/util/urlHelper';

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusOpenAccess: React.FC = () => (
  <div className={styles.ideaStatusOpenAccess}>
    <div>
      <FontAwesomeIcon className={styles.faIcon} icon={faExclamationCircle} />
      <strong>Open Access:</strong> All members may view this idea regardless of current database
      status.
    </div>
    <Link to={accessIdeasUrl()}>Learn How to Access All SumZero Research.</Link>
  </div>
);

export default IdeaStatusOpenAccess;
